import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import Button from '@components/shared/Button'
import MustLoginDialog from '@components/shared/dialogs/MustLoginDialog'
import PurchaseLearnDialog from '@components/shared/dialogs/PurchaseLearnDialog'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import AccessPremiumContentDialog from '../../AccessPremiumContentDialog'
import CreateEditableCopyDialog from './CreateEditableCopyDialog'

const EditableCopyButton: React.FC = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { title } = useContext(TitleContext)
  const openDialog = useDialogStore((s) => s.openDialog)
  const session = useSession()

  const onClick = (): void => {
    if (isLearnPcPreview(pathname)) {
      openDialog('purchase_learn')
    } else if (!session.isLoggedIn()) {
      openDialog('must_login_editable_copy')
    } else if (title.permissions?.can_copy) {
      openDialog('create_editable_copy')
    } else {
      openDialog('access_premium_content')
    }
  }

  return (
    <>
      <Button variant="outline" onClick={onClick} className="text-md !px-0 py-1.5">
        {t('action.editableCopy')}
      </Button>

      <PurchaseLearnDialog />
      <AccessPremiumContentDialog />
      <CreateEditableCopyDialog />
      <MustLoginDialog
        title={t('content.copyToEditor')}
        action={t('content.copyToEditor')}
        name="must_login_editable_copy"
      />
    </>
  )
}

export default EditableCopyButton
